import { gql } from '@apollo/client'

export const GENERATE_AUTH_TOKEN = gql`
  mutation generateAuthToken($input: TokenForAuthenticationInput!) {
    authenticateClientForToken(input: $input) {
      token
    }
  }
`
